import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import RSVPForm from "./RSVPForm registartion closed";

const WelcomeMeet = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#rsvp-form") {
      const mapElement = document.getElementById("rsvp-form");
      if (mapElement) {
        mapElement.scrollIntoView({ behavior: "auto" });
      }
    }
  }, [location]);

  // Variants for animation
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  // Add `\n` where you want a line break
  const headingText = "Strengthening the Voice of\nthe MSB Sector";

  useEffect(() => {
    // Scroll to form only if hash is present
    if (location.hash === "#rsvp-form") {
      const formElement = document.getElementById("rsvp-form");
      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const title = "Annual Members Meet 2026";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Welcome - Annual Members Meet 2026 | MSB Association</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Welcome - Annual Members Meet 2026 | MSB Association " />
        <meta property="og:description" content="" />

        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section className="page_header text-center section_decoration overflow-hidden bg-image-css">
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                      gap: "0.4rem"
                    }}
                  >
                    {line.split(" ").map((word, wordIndex) => (
                      <span
                        key={`word-${lineIndex}-${wordIndex}`}
                        style={{
                          display: "inline-block",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {word.split("").map((letter, charIndex) => {
                          const uniqueIndex = lineIndex * 50 + wordIndex * 15 + charIndex;
                          return (
                            <motion.span
                              key={`char-${lineIndex}-${wordIndex}-${charIndex}`}
                              custom={uniqueIndex}
                              initial="hidden"
                              animate="visible"
                              variants={letterVariants}
                              style={{
                                display: "inline-block",
                              }}
                            >
                              {letter}
                            </motion.span>
                          );
                        })}
                      </span>
                    ))}
                  </div>
                ))}
            </motion.h1>
            
            <div className="d-flex justify-content-center align-items-center mb-4 mt-2 flex-wrap" style={{ color: "#fff" }}>
              <span className="me-2" style={{ fontSize: "18px" }}>Co-sponsored by</span>
              <img 
                src="/assets/images/clear-junction-logo.svg" 
                alt="Clear Junction Logo" 
                className="img-fluid"
                style={{ height: "40px", objectFit: "contain", maxWidth: "200px" }} 
              />
            </div>

            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink
                  to="/"
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    lineHeight: "25px",
                  }}
                >
                  Thursday, 16 April 2026 | 6:00 PM Onwards
                  <br />
                  <br />
                  📍 Leonardo Royal Hotel St Paul’s
                </NavLink>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content">
              <h2 className="item_details_heading text-center">
                {headingText.split("").map((char, i) => {
                  if (char === "\n") {
                    return <br key={`br-${i}`} />;
                  }
                  return (
                    <motion.span
                      key={`${char}-${i}`}
                      custom={i}
                      initial="hidden"
                      animate="visible"
                      variants={headingVariants}
                    >
                      {char}
                    </motion.span>
                  );
                })}
              </h2>
              <p>
                The MSB Association is proud to invite you to our <strong>Annual Members Meet 2026</strong> - co sponsored by <strong>Clear Junction</strong> — an exclusive gathering of leaders, directors, compliance professionals, and decision-makers from across the Money Service Business sector.
              </p>
              <p>
                Following the success of our inaugural event, this year’s meet aims to further strengthen collaboration, deepen regulatory engagement, and advance the collective interests of the MSB community. <br />
                Join us for an evening of strategic dialogue, industry insight, and high-value networking in one of London’s premier venues.
              </p>
              <p>
                <strong>Co-Sponsored by Clear Junction</strong><br />
                We are proud to have Clear Junction as our Co-Sponsor, supporting the event and promoting stronger industry collaboration. Their partnership reflects a shared commitment to innovation, compliance excellence, and sustainable growth within the MSB ecosystem.
              </p>

              <h5 className="mb-3">Why Attend?</h5>
              <ul className="mb-4 " >
                <li className="mb-2"> Network with over <strong>60+ MSB business owners and decision makers</strong></li>
                <li className="mb-2"> Gain insights from regulatory, legal, and fintech experts</li>
                <li className="mb-2"> Engage in meaningful dialogue on shaping a compliant, competitive and progressive MSB sector</li>
                <li className="mb-2"> Explore collaborative opportunities and partnership within the MSB community</li>
                <li className="mb-2"> Contribute to shaping a stronger, more unified industry voice</li>
              </ul>
              <p className="mb-4">
                This event is designed to foster meaningful engagement and practical dialogue that benefits all regulated businesses within the sector.
              </p>

              {/* <h5 className="mb-3">Special Guest:</h5>
              <p>
                We are pleased to share that <strong>representatives from the FCA and HMRC</strong> have been invited to join us for this special evening. Their participation, subject to confirmation, will offer members a valuable opportunity to engage directly with key regulators, gain insight into current supervisory priorities, and better understand evolving compliance expectations.
              </p> */}

              <h5 className="mb-3 mt-4">Member Participation & Subscription</h5>
              <p className="mb-2">
                As a not-for-profit association, the MSB Association depends on the active support of its members to deliver impactful events, advocacy, and industry representation.
              </p>
              <p className="mb-2">
                We kindly request all members to ensure their <strong>annual subscription fee is settled prior to attending</strong>. These contributions help us:
              </p>
              <ul className="mb-4">
                <li>Cover venue and event costs</li>
                <li>Support regulatory engagement</li>
                <li>Deliver member services and initiatives</li>
                <li>Strengthen the collective influence of the MSB sector</li>
              </ul>
              <p className="mb-4">
                Your support ensures the continued growth and credibility of our community.
              </p>

              <h5 className="mb-3 mt-4">RSVP</h5>
              <p className="mb-2">
                Attendance is limited and early confirmation is strongly encouraged.
              </p>
              <p className="mb-2">
                Please complete the registration form below to secure your place at the MSB Association Annual Members Meet 2026.
              </p>
              <p>
                <strong>We look forward to welcoming you.</strong>
              </p>

              <div className="row mb-4 mt-4 align-item-center" id="rsvp-form">
                <div className="col-lg-6 col-md-6 col-12">
                  <h5 className="mb-3">Event Program</h5>
                  <div className="schedule-date">
                    Thursday, 16 April 2026
                  </div>
                  <div className="schedule-card">
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Welcome Drinks & Registration
                        </h6>
                      </div>
                      <div>6:00 PM – 6:30 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">Welcome Address by the MSB Association Board</h6>
                      </div>
                      <div>6:30 PM – 6:45 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                           Discussion Panel
                        </h6>
                      </div>
                      <div>6:50 PM – 7:10 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                         Key Note Speaker
                        </h6>
                      </div>
                      <div>7:15 PM – 7:30 PM</div>
                    </div>
                    <div className="schedule-item">
                      <div>
                        <h6 className="fw-bold mb-1">
                          Networking, Drinks & Refreshments
                        </h6>
                      </div>
                      <div>7:45 PM – 9:00 PM</div>
                    </div>
                  </div>

                  <div className="schedule-date mt-4">Venue</div>
                  <div className="schedule-card p-0">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.219803099908!2d-0.10125882329241687!3d51.512613010574044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604aca2f11815%3A0xcfdac0421e3f8ec4!2sLeonardo%20Royal%20Hotel%20London%20St%20Paul&#39;s!5e0!3m2!1sen!2suk!4v1714486510486!5m2!1sen!2suk"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      className="iframe-map"
                      style={{ border: 0, width: "100%", height: "250px" }}
                    ></iframe>
                    <div className="p-4">
                      <h6 className="fw-bold mb-1">
                        Leonardo Royal Hotel St Paul’s
                      </h6>
                      <p className="mb-1 ">10 Godliman Street, London, EC4V 5AJ, GB</p>
                      <p className="mb-0 ">Located in the heart of the City of London.</p>
                    </div>
                  </div>
                </div>
                <hr className="d-block d-sm-none" />
                <div className="col-lg-6 col-md-6 col-12">
                  <RSVPForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default WelcomeMeet;
